<template>
  <div class="xscontainer jsjiesh">
<!--    <div class="urtyery">-->
<!--      <el-page-header @back="goBack" content="行业专家">-->
<!--      </el-page-header>-->
<!--    </div>-->
    <div class="kskdlld">
<!--      <div class="zjjscerr">行业专家</div>-->
      <div class="leftandright">
        <div class="leftdiv">
          <div class="touxiang1" v-for="(item,index) in leftJss" @click="queryJiangshibyname(item.zjname)">
            <img class="tx1" :src="item.zjtx">
            <div>
              <p class="renming">{{item.zjname}}</p>
              <p class="zwj">{{item.jianjie}}</p>
            </div>
          </div>
        </div>
        <div class="rightdiv">
          <div class="tx">
            <img :src="currentJs.zjtx">
            <div class="mzjs">
              <p class="jsxm">{{currentJs.zjname}}</p>
              <p class="jszw">{{currentJs.jianjie}}</p>
            </div>
          </div>
          <div class="ukdw">
            <p class="tt">个人介绍</p>
            <p class="jsxq">
              {{currentJs.zjjs}}
            </p>
          </div>
          <div class="ukdw">
            <p class="tt166">擅长领域</p>
            <div class="scly">
              <div class="sckc" v-for="(item,index) in sclys">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jslist:[],
      jsname:'',
      currentJs:{},
      sclys:[],
      endIndex: 7,
      leftJss:[],
      fwcishu:0
    };
  },
  mounted() {
    this.queryJiangshis();

    let params = this.$route.query;
    let name = params.name;
    this.queryJiangshibyname(name);
  },
  created() {
    this.tongji('讲师介绍');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    goBack(){
      this.$router.back()
    },
    load () {

    },
    queryJiangshis () {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhuanjia/tZhuanjia/list?_t='+new Date().getTime()+'&column=pxh&order=asc&field=id,jianjie,zjjs,zjtx,action&pageNo='+0+'&pageSize='+100)
          .then(function (response) {
            if (response.data.code == 200) {
              that.jslist = response.data.result.records;
              that.leftJss = that.jslist;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });

    },
    queryJiangshibyname (jiangshiname) {
      if(jiangshiname){
        this.jsname = jiangshiname;
      }
      debugger
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhuanjia/tZhuanjia/list?_t='+new Date().getTime()+'&column=pxh&order=asc&order=asc&field=id,jianjie,zjjs,zjtx,action&pageNo='+0+'&pageSize='+1+"&zjname="+this.jsname)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.currentJs = response.data.result.records[0];
              var scly = that.currentJs.scly;
              that.sclys = scly.split(",");
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
  }
};
</script>

<style scoped>
.kskdlld{
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
}
.urtyery{
  width: 100%;
  display: flex;
  justify-content: start;
}
.zjjscerr{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;

}
.leftandright{
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 2rem;
}
.leftdiv{
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 1rem 1rem 1rem;
  gap:0.5rem;
  overflow-y: auto;
  overflow-x: hidden;
}
.rightdiv{
  width: 75%;
  background-color: #f2f9ff;
  display: flex;
  flex-direction: column;
  gap:1rem;
  padding: 4rem 3rem;
}
.touxiang1{
  min-width: 13rem;
  min-height: 5rem;
  display: flex;
  gap:1rem;
  align-items: center;
}
.touxiang1:hover{
  min-width: 13rem;
  min-height: 5rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 3px;
  box-shadow: 0px 1px 8px 1px rgb(196, 194, 194);
  cursor: pointer;
}
.tx1{
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.renming{
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 1px;
}
.zwj{
  color: #7e7c7c;
  font-size: 11px;
  margin-top: 3px;
  letter-spacing: 1px;
}

.tx{
  display: flex;
  gap:2rem;
}
.tx img{
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}
.mzjs{
  display: flex;
  flex-direction: column;
  gap:0.5rem;
  justify-content: center;
}
.jsxm{
  font-weight: bold;
  font-size: 1.4rem;
  letter-spacing: 1px;
}
.jszw{
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 1px;
}
.ukdw{
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap:1.5rem;
}
.tt{
  color: #127bf9;
  font-weight: bold;
  font-size: 0.8rem;
}
.jsxq{
  color: #7e7c7c;
  letter-spacing: 1px;
  line-height: 32px;
}
.tt166{
  color: #127bf9;
  font-weight: bold;
  font-size: 13px;
  margin-top: 20px;
}
.scly{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.sckc{
  color: #127bf9;
  font-weight: bold;
  font-size: 14px;
  width: 11rem;
  height: 3.5rem;
  border-radius: 1px;
  background-color: #ffffff;
  line-height: 3.5rem;
  text-align: center;
  box-shadow: 0px 0px 3px 0px #127bf9;
}
</style>
